import { createSlice } from '@reduxjs/toolkit';
import { staticRoutes } from 'app/configs/routesConfig';
import { getAsyncFilteredRoutes, mergeRoutes } from 'app/store/routes/utils';
import { buildAsyncRoutes, clearAsyncRoutes } from './asyncThunks';

// ------ Authentication --------
const userInitialState = {
  isLoading: true,
  errors: [],
  routes: getAsyncFilteredRoutes(),
};
const routesSlice = createSlice({
  name: 'routes',
  initialState: userInitialState,
  reducers: {
    setRoutes: (state, { payload }) => {
      const { asyncNewRoutes } = payload;
      return {
        ...state,
        isLoading: false,
        routes: mergeRoutes(state.routes, asyncNewRoutes),
      };
    },
    resetRoutes: (state) => {
      const routes = getAsyncFilteredRoutes();
      return {
        ...state,
        isLoading: false,
        routes,
      };
    },
  },
  extraReducers: {
    // ------------- Build Authenticated Routes -------------
    [buildAsyncRoutes.pending]: (state) => {
      return { ...state, isLoading: true };
    },
    [buildAsyncRoutes.fulfilled]: (state, { payload }) => {
      const { selected } = payload;
      return {
        ...state,
        isLoading: false,
        errors: [],
        routes: mergeRoutes(staticRoutes, selected),
      };
    },
    [buildAsyncRoutes.rejected]: (state, { payload }) => {
      return { ...state, isLoading: false, errors: payload };
    },
    // ------------- Build Unauthenticated Routes -------------
    [clearAsyncRoutes.pending]: (state) => {
      return { ...state, isLoading: true };
    },
    [clearAsyncRoutes.fulfilled]: (state, { payload }) => {
      const { selected } = payload;
      return {
        ...state,
        isLoading: false,
        errors: [],
        routes: mergeRoutes(staticRoutes, selected),
      };
    },
    [clearAsyncRoutes.rejected]: (state, { payload }) => {
      return { ...state, isLoading: false, errors: payload };
    },
  },
});

export default routesSlice.reducer;
export const { setRoutes, resetRoutes } = routesSlice.actions;
